import { AfterViewInit, Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WindowSizeDirective } from 'src/app/shared/directives/window-size.directive';

@Component({
  selector: 'app-lp-footer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './lp-footer.component.html',
  styleUrls: ['./lp-footer.component.scss'],
  hostDirectives: [ WindowSizeDirective ]
})
export class LpFooterComponent implements OnInit, AfterViewInit {

  constructor() { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    const script = document.createElement('script');
    script.id = '1-43c2cd496486bcc27217c3e790fb4088';
    script.dataset['a'] = 'lektory';
    script.src = 'https://d70shl7vidtft.cloudfront.net/widget.js';
    script.async = true;

    document.head.appendChild(script);
  }

}
